import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { StaticImage } from 'gatsby-plugin-image'

// import SearchIcon from '../../../static/images/search-icon.svg'
// import { HiOutlineShoppingBag } from "react-icons/hi"
import SideBarMenu from '../sidebar/Sidebar'
import Searchicon from '../../../static/images/search-icon.svg'
import Search from '../react-search-comp'
import './menu.scss'

import { Navbar } from 'react-bootstrap'
// import Cart from '../ecwid/cart'

const Header = () => {
  const [scrollY, setScrollY] = useState(0)
  function logit() {
    setScrollY(window.pageYOffset)
  }
  useEffect(() => {
    function watchScroll() {
      window.addEventListener('scroll', logit)
    }
    watchScroll()
    // Remove listener (like componentWillUnmount)
    return () => {
      window.removeEventListener('scroll', logit)
    }
  }, [])
  const pages = useStaticQuery(graphql`
    query HeaderQuery {
      allSitePage {
        edges {
          node {
            path
          }
        }
      }
    }
  `)
  const data = pages.allSitePage
  return (
    <>
      <header
        id="navbar"
        className="navbar-wrapper"
        style={{ background: '#fff' }}
      >
        <div className="main-header">
          <Navbar
            fixed="top"
            style={{
              backgroundColor: '#ffffff',
              boxShadow: scrollY > 0 ? '0px 3px 6px #00000029' : 'none',
              // border: scrollY > 0 ? 'none' : '1px solid #e8e9eb',
              flexFlow: 'wrap',
              padding: 0,
            }}
          >
            {scrollY > 0 ? null : (
              <div className="w-100" style={{ backgroundColor: '#003B3D' }}>
                <div className="header-banner px-4 py-3">
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 col-6">
                      <a
                        class="navbar-brand text-white mr-lg-auto"
                        href="tel:1-833-234-6348"
                      >
                        <StaticImage
                          className="vector-call"
                          src="../../../static/images/Vector-call.svg"
                          alt="call-logo"
                        />
                        +1 833 234 6348
                      </a>
                      <div className="col p-0">
                        <a href="http://discovery.ariba.com/profile/AN01553361852">
                          <img
                            className="pr-5 ariba-img"
                            alt="View Perin Discovery profile on Ariba Discovery"
                            src="https://service.ariba.com/an/p/Ariba/badge_245x100.jpg"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-6 d-lg-block d-md-block d-none text-right">
                      {/* <span class="navbar-text"> */}
                      <Link
                        to="/about-us/"
                        className="text-white mr-5"
                        style={{
                          display: 'inline-block',
                          fontSize: '1.25rem',
                          lineHeight: 'inherit',
                          // padding-bottom: .3125rem;
                          // padding-top: .3125rem;
                          whiteSpace: 'nowrap',
                        }}
                      >
                        ABOUT US
                      </Link>
                      <Link
                        to="/contact-us/"
                        className="text-white"
                        style={{
                          display: 'inline-block',
                          fontSize: '1.25rem',
                          lineHeight: 'inherit',
                          // padding-bottom: .3125rem;
                          // padding-top: .3125rem;
                          whiteSpace: 'nowrap',
                        }}
                      >
                        CONTACT US
                      </Link>

                      {/* </span> */}
                    </div>
                    <div className="col">
                      <div className="header-search">
                        <LazyLoadImage
                          effect="blur"
                          className="search-icon"
                          src={Searchicon}
                          alt="search-icon"
                          style={{ marginTop: '1px' }}
                        />
                        <Search data={data} />
                      </div>
                    </div>
                  </div>

                  {/* <Link
                    to="/shop"
                    style={{
                      width: '100%',
                      display: 'block',
                      padding: '10px 55px',
                      color: '#fff',
                    }}
                  >
                    FREE SHIPPING IN THE CONTINENTAL US
                  </Link> */}
                </div>
              </div>
            )}
            <div
              // className="nav d-flex flex-wrap w-100"
              className="d-flex flex-wrap w-100"
              style={{ paddingTop: '1rem', paddingBottom: '1rem' }}
            >
              <div
                className="container-fluid"
                style={{ justifyContent: 'unset' }}
              >
                <div className="col-lg-2 col-md-4 col-5 mr-lg-0 mr-md-0 mr-auto logo-img-wrapper">
                  <Link to="/">
                    <StaticImage
                      style={{ width: '200px' }}
                      src="../../../static/images/Perin_Logo_Horizontal_V5.svg"
                      alt="Site Logo"
                    />
                  </Link>
                </div>
                <div className="col-lg-9 col-md-9 d-lg-inline d-md-none d-none main-menu-wrapper">
                  <div className="menu-items">
                    <Link
                      to="/8a-sole-source-advantages/"
                      // className="mr-lg-3 mr-md-4"
                      style={{
                        fontFamily: 'Montserrat',
                        fontStyle: 'bold',
                        fontSize: '18px',
                        fontWeight: 500,
                        /* padding: 1px 100px 1px 1px; */
                        letterSpacing: '0.2px',
                        color: '#003B3D',
                        marginRight: '5vw',
                      }}
                    >
                      8A SOLE SOURCE ADVANTAGES
                    </Link>
                    <Link
                      to="/our-services/"
                      // className="mr-lg-3 mr-md-4"
                      style={{
                        fontFamily: 'Montserrat',
                        fontStyle: 'bold',
                        fontSize: '18px',
                        fontWeight: 500,
                        /* padding: 1px 100px 1px 1px; */
                        letterSpacing: '0.2px',
                        color: '#003B3D',
                        marginRight: '5vw',
                      }}
                    >
                      OUR SERVICES
                    </Link>
                    <Link
                      to="/news/"
                      // className="mr-lg-3 mr-md-4"
                      style={{
                        fontFamily: 'Montserrat',
                        fontStyle: 'bold',
                        fontSize: '18px',
                        fontWeight: 500,
                        /* padding: 1px 100px 1px 1px; */
                        letterSpacing: '0.2px',
                        color: '#003B3D',
                        marginRight: '5vw',
                      }}
                    >
                      PERIN INSIGHTS
                    </Link>
                    <Link
                      to="/data-encryption/"
                      // className="navbar-text-header"
                      style={{
                        fontFamily: 'Montserrat',
                        fontStyle: 'bold',
                        fontSize: '18px',
                        fontWeight: 500,
                        /* padding: 1px 100px 1px 1px; */
                        letterSpacing: '0.2px',
                        color: '#003B3D',
                      }}
                    >
                      DATA ENCRYPTION
                    </Link>
                  </div>
                </div>
                {/* <div className="col-4 col-lg-4 col-md-2 text-lg-right text-md-right">
                  <div className="logo d-flex align-items-center justify-content-end">
                    <Link
                      to="/"
                      className="mr-lg-4 mr-md-3 mr-2"
                      aria-label="Search"
                    >
                      <img src={SearchIcon} alt="search" />
                    </Link>
                  </div>
                </div> */}
                <div className="col-4 col-lg-12 col-md-8 d-lg-none d-md-inline d-inline text-lg-left text-md-right text-right sidebar-menu-wrapper">
                  <SideBarMenu />
                </div>
              </div>
            </div>
          </Navbar>
        </div>
      </header>
    </>
  )
}

export default Header
